import { Stack } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { BlockClicks } from "lib/@components/block-clicks"
import { If } from "lib/@components/switch"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"

export function ReasonInput({ value, setValue, label, disabled, onSave, dataCy }) {
    // When the box opens already pre-filled (e.g. from a share-link comment), its initial text is valid,
    // so enable Save immediately — the host shouldn't have to edit a character just to un-disable it.
    const startValid = `${value?.reason ?? ""}`.trim().length > 0

    return (
        <If value={value}>
            <BlockClicks>
                <Stack sx={{ flex: 1 }}>
                    <DataInputDialog
                        initialValue={value}
                        startValid={startValid}
                        disableKeys={true}
                        okCaption="Save"
                        ok={onSave}
                        cancel={handleCancel}
                        okDisabled={() => disabled}
                    >
                        <BoundTextField
                            data-cy={dataCy || "reason-text-field"}
                            field="reason"
                            label={label}
                            margin="normal"
                            multiline
                            minRows={5}
                            maxRows={10}
                            overflow="scroll"
                            autoFocus={true}
                            yup="string.trim.required"
                            InputLabelProps={{ shrink: true }}
                            sx={{ "& .MuiInputBase-root": { backgroundColor: "background.paper" } }}
                        />
                    </DataInputDialog>
                </Stack>
            </BlockClicks>
        </If>
    )

    function handleCancel() {
        setValue(null)
    }
}
